export default __webpack_public_path__ + "static/media/menu-web-icon.537f673b.svg";